export enum FrequencyOptions {
  single = 'single',
  daily = 'daily',
  weekly = 'weekly',
  bi_weekly = 'bi_weekly',
  monthly = 'monthly',
  bi_monthly = 'bi_monthly',
  quarterly = 'quarterly',
  quadrimester = 'quadrimester',
  semiannual = 'semiannual',
  annual = 'annual',
}

export enum Options {
  template = 'template',
  custom = 'custom',
  workflow = 'workflow',
}

export enum Templates {
  climate = 'climate',
  workflow = 'workflow_survey',
}

export enum Types {
  custom = Options.custom,
  climate = Templates.climate,
  workflow = Templates.workflow,
}
